export default __webpack_public_path__ + "static/media/alan2.b64fb7d1.png";